<template>
  <div>
    <div class="logo" @click="toggleMenu">
      <i id="hamburger" class="material-icons">menu</i>
    </div>
    <div :class="{ 'menu-open': isMenuOpen }" class="menu">
      <div id="close-icon" @click="closeMenu">
        <i class="material-icons">close</i>
      </div>
      <div class="menu-item-continer">
        <div class="menu-item" @click="goToHomePage"><i class="material-icons">home</i>&nbsp;Homepage</div>
        <div class="menu-item" @click="goToMenu"><i class="material-icons">restaurant_menu</i>&nbsp;Menu utente</div>
        <div class="menu-item" @click="handleManageProduct"><i class="material-icons">edit</i>&nbsp;Modifica piatti
        </div>
        <div class="menu-item" @click="handleAddNewProduct"><i class="material-icons">add_box</i>&nbsp;Aggiungi nuovo
          piatto</div>
        <div class="menu-item" @click="handleManageCategory"><i class="material-icons">category</i>&nbsp;Modifica
          categorie</div>
        <div class="menu-item" @click="handleAddNewCategory"><i class="material-icons">add_box</i>&nbsp;Aggiungi nuova
          categoria</div>
        <div class="menu-item" @click="handleDailyMenu"><i class="material-icons">today</i>&nbsp;Modifica Menu del
          giorno</div>
        <div class="menu-item" @click="goToDailyMenu"><i class="material-icons">link</i>&nbsp;Menu del giorno</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        setTimeout(() => {
          document.addEventListener('click', this.closeMenuOutside);
        });
      } else {
        document.removeEventListener('click', this.closeMenuOutside);
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.removeEventListener('click', this.closeMenuOutside);
    },
    closeMenuOutside(event) {
      if (!event.target.closest('.menu')) {
        this.closeMenu();
      }
    },
    handleManageProduct() {
      this.closeMenu();
      this.$emit('all-dishes');
    },
    goToHomePage() {
      this.closeMenu();
      this.$router.push('/');
    },
    goToMenu() {
      this.closeMenu();
      this.$router.push('/menu');
    },
    handleAddNewProduct() {
      this.closeMenu();
      this.$emit('new-dishes');
    },
    handleManageCategory() {
      this.closeMenu();
      this.$emit('all-category');
    },
    handleAddNewCategory() {
      this.closeMenu();
      this.$emit('new-category');
    },
    handleDailyMenu() {
      this.closeMenu();
      this.$emit('daily-menu');
    },
    goToDailyMenu() {
      this.closeMenu();
      this.$router.push('/dailyMenu');
    }
  }
};
</script>


<style>
#hamburger {
  position: fixed;
  top: 8px;
  left: 8px;
  font-size: 40px;
  color: var(--accent-color);
  z-index: 4;
}

.menu {
  position: fixed;
  top: 55px;
  left: -250px;
  bottom: 0;
  width: 250px;
  background-color: #1b1b1b;
  padding: 20px;
  transition: left 0.3s ease-out;
  z-index: 1;
}

.menu-item {
  display: flex;
  /* Utilizza flexbox per allineare verticalmente il testo e l'icona */
  align-items: center;
  /* Allinea gli elementi verticalmente */
  border-bottom: solid;
  border-width: 1px;
  height: 50px;
  border-color: #808080;
  color: white;
  padding: 12px 0;
}

#close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.menu-open {
  left: 0;
}

.menu-item-continer {
  margin-top: 30px;
}

#croissant {
  font-size: 40px;
  margin-left: 10px;


}
</style>
